import React, { createContext, useContext, useState, useEffect } from 'react';

const ServiceContext = createContext();

// Services are per-company and start empty — each workspace creates its own
// service types from Tools > Service Types. No defaults are seeded.
function loadInitial() {
  // One-time cleanup: older builds seeded a default service list into
  // localStorage. Clear it once per browser so workspaces start clean.
  try {
    if (!localStorage.getItem('ryzenos_svc_reset')) {
      localStorage.removeItem('ryzenos_services');
      localStorage.setItem('ryzenos_svc_reset', '1');
    }
  } catch {}
  try {
    const saved = JSON.parse(localStorage.getItem('ryzenos_services') || 'null');
    if (Array.isArray(saved)) return saved;
  } catch {}
  return [];
}

export function ServiceProvider({ children }) {
  const [services, setServices] = useState(loadInitial);

  useEffect(() => {
    localStorage.setItem('ryzenos_services', JSON.stringify(services));
  }, [services]);

  const add    = (s) => { if(s.trim() && !services.includes(s.trim())) setServices(p=>[...p,s.trim()]); };
  const remove = (s) => setServices(p=>p.filter(x=>x!==s));
  const edit   = (old,nw) => { if(nw.trim()) setServices(p=>p.map(x=>x===old?nw.trim():x)); };
  return <ServiceContext.Provider value={{services,add,remove,edit}}>{children}</ServiceContext.Provider>;
}

export const useServices = () => useContext(ServiceContext);
